import React, {useEffect} from 'react'
import {SeatingPlanModal} from '../chunks'
import {ModalsProps} from './interfaces'
import {OrderSummary} from './order-summary'
import {NativeModal} from './constants'
import {TicketsDownload} from './tickets-download'
import {ConfirmRsvp} from './confirm-rsvp'
import {HeadlessError} from './headless-error'

export const Modals = ({modalType, plan, blockScroll, unblockScroll}: ModalsProps) => {
  useEffect(() => {
    if (modalType) {
      blockScroll?.()
    } else {
      unblockScroll?.()
    }
    return () => {
      unblockScroll?.()
    }
  }, [modalType])

  switch (modalType) {
    case NativeModal.ORDER_SUMMARY:
      return <OrderSummary />
    case NativeModal.TICKETS_DOWNLOAD:
      return <TicketsDownload />
    case NativeModal.SEATING_PLAN:
      if (!plan) {
        return null
      }

      return <SeatingPlanModal />
    case NativeModal.CONFIRM_RSVP:
      return <ConfirmRsvp />
    case NativeModal.HEADLESS_ERROR:
      return <HeadlessError />
    default:
      return null
  }
}
